module.exports = __webpack_public_path__ + "static/media/014.f0e969e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/014.jpg
// module id = 311
// module chunks = 0